export enum NegativeNumberType {
  Common = 'Common',
  CommonWithWhiteSpace = 'CommonWithWhiteSpace',
  Money = 'Money',
}
